import PhotoSwipeLightbox, { type DataSource } from 'photoswipe/lightbox'
import 'photoswipe/style.css'

export function useLightbox(containerId: string) {
  const lightbox = ref<Nullable<PhotoSwipeLightbox>>(null)

  const init = () => {
    if (lightbox.value) return

    lightbox.value = new PhotoSwipeLightbox({
      gallery: `#${containerId}`,
      children: 'img',
      pswpModule: () => dynamicImport(() => import('photoswipe'), 'photoswipe'),
      showHideAnimationType: 'zoom',
      wheelToZoom: true,
    })
    lightbox.value.init()
    lightbox.value.addFilter('domItemData', (_itemData, element) => {
      const _element = element as HTMLImageElement

      return {
        src: _element.src,
        w: _element.naturalWidth,
        h: _element.naturalHeight,
      }
    })
  }

  const open = (index = 0) => {
    if (!lightbox.value) return false

    const gallery = document.querySelector(`#${containerId}`)
    if (!gallery) return false

    lightbox.value.loadAndOpen(index, { gallery: gallery } as DataSource)
  }

  const destroy = () => {
    if (!lightbox.value) return false
    lightbox.value?.destroy()
  }

  onScopeDispose(() => {
    destroy()
  })

  return {
    lightbox,
    init,
    open,
    destroy,
  }
}
